import { AlertBar, AlertBarVariant } from '../AlertBar/AlertBar'
import { FixedTop } from './NetworkStatusBar.styles'

interface NetworkStatusBarProps {
  variant: AlertBarVariant
  message: string
}

/** Aviso global de conexão/frescor de dado. Reaproveita o visual do `AlertBar`, só fixa no topo. */
function NetworkStatusBar({ variant, message }: NetworkStatusBarProps) {
  return (
    <FixedTop $variant={variant} role="status" aria-live="polite">
      <AlertBar variant={variant} message={message} />
    </FixedTop>
  )
}

export { NetworkStatusBar }
